import { Box, Stack } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { FormFields, Layout, PageSection } from '@product-framework/index';
import { FormEdit, useLocalization, useUserAccess } from '@ui-framework/index';
import { useRef } from 'react';
import {
  UserResetMFADialogWithButton,
  UserUpdatePasswordDialogWithButton,
} from '@product-framework/components/Dialogs';
import editSchema from './schemas/edit.json';

function Profile() {
  const editFormRef = useRef();
  const { formatMessage } = useLocalization();

  const userAccess = useUserAccess();

  const formProps = {
    customComponents: FormFields,
    schema: editSchema,
    onSubmit: null,
    ref: editFormRef,
    initialValues: {
      firstName: userAccess.firstName,
      lastName: userAccess.lastName,
      email: userAccess.email,
      companyName: userAccess?.company?.companyNumber,
      userRole: userAccess?.role?.roleIdentifier,
    },
    validationSchema: null,
  };

  return (
    <Layout>
      <Grid2 xs={12}>
        <PageSection
          label={formatMessage({
            id: 'MY_USER_PROFILE',
            defaultMessage: 'My Profile',
          })}>
          <Box>
            <FormEdit {...formProps} />
          </Box>
          <Stack
            direction="row"
            justifyContent="center"
            sx={{ mt: 3, mb: 2 }}
            gap={1}>
            <UserUpdatePasswordDialogWithButton
              email={userAccess?.email}
              firstName={userAccess?.firstName}
              lastName={userAccess?.lastName}
              permissionName="CAN_UPDATE_SELF_PASSWORD"
            />
            <UserResetMFADialogWithButton
              email={userAccess?.email}
              firstName={userAccess?.firstName}
              lastName={userAccess?.lastName}
              permissionName="CAN_RESET_SELF_USER_MFA"
            />
          </Stack>
        </PageSection>
      </Grid2>
    </Layout>
  );
}
export default Profile;
